export const DOMAINS = {
  domains: ['hotmail.com', 'gmail.com', 'aol.com', 'yahoo.com', 'yahoo.com.au', 'yahoo.com.ar', 'bigpond.com',
            'optusnet.com.au', 'tpg.com.au', 'iinet.net.au', 'me.com', 'mac.com', 'outlook.com',
            'live.com', 'comcast.net', 'googlemail.com', 'msn.com', 'hotmail.co.uk', 'yahoo.co.uk',
            'facebook.com', 'verizon.net', 'sbcglobal.net', 'att.net', 'gmx.com', 'mail.com', 'icloud.com'],
  secondLevelDomains: ['hotmail'],
  topLevelDomains: []
}
